import { Chip, Css, MultiSelectField } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { observer } from "mobx-react";
import { PotentialBidPlanDimensionKind } from "src/generated/graphqlTypes";
import {
  ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOptionFragment,
  ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment,
} from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { PlanBasedBidPackageBidPlanGroup } from "src/routes/bids/plan-based-bid-package/utils";

type BidPlanDimensionRowsProps = {
  group: ObjectState<PlanBasedBidPackageBidPlanGroup>;
  dimensionResults: ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment[];
};

export const BidPlanDimensionRows = observer(function BidPlanDimensionRows(props: BidPlanDimensionRowsProps) {
  const { group, dimensionResults } = props;
  return (
    <div css={Css.df.fdc.gap2.$}>
      {dimensionResults.map((result) => {
        // Group-based dimensions match on globalOptionGroupId; type-based ones on globalOptionTypeId.
        const isPersonalization = result.kind === PotentialBidPlanDimensionKind.Personalization;
        const dim = group.dimensions.rows.find((d) =>
          isPersonalization
            ? d.globalOptionGroupId.value === result.group?.id
            : d.globalOptionTypeId.value === result.type?.id,
        );
        if (!dim) return null;
        const label = isPersonalization ? result.group!.name : result.type!.name;
        return (
          <MultiSelectField
            fullWidth
            key={result.id}
            label={label}
            values={dim.globalOptionIds.value ?? []}
            options={result.options}
            onSelect={(ids) => dim.globalOptionIds.set(ids)}
            getOptionMenuLabel={getOptionMenuLabel}
            errorMsg={dim.globalOptionIds.value?.isEmpty ? "At least one option is required" : undefined}
          />
        );
      })}
    </div>
  );
});

/** Show the plan name to tell apart global options with the same name from different plans (e.g. ADU vs main house). */
function getOptionMenuLabel(go: ConfigureBidGroupsStep_PotentialBidPlanDimension_GlobalOptionFragment) {
  if (!go?.readyPlan) return go?.name;
  return (
    <div css={Css.df.aic.jcsb.gap1.w100.$}>
      {go.name}
      <Chip text={go.readyPlan.name} compact title={go.readyPlan.name} />
    </div>
  );
}
